import React, { useContext, useEffect, useRef } from 'react';
import { Title } from '@investoro/core';
import PropertyValuationContext from 'utils/context/PropertyValuationContext';

import ValuationAiSummary from './sections/ValuationAiSummary';
import ValuationHeroCard from './sections/ValuationHeroCard';
import ValuationLocation from './sections/ValuationLocation';
import ValuationMarketContext from './sections/ValuationMarketContext';
import ValuationMarketProof from './sections/ValuationMarketProof';
import ValuationPlanB from './sections/ValuationPlanB';
import { ReportWrapper } from './common';

interface ValuationReportResultProps {
    onExportPdf?: () => void;
    isExportingPdf?: boolean;
}

const ValuationReportResult = ({ onExportPdf, isExportingPdf }: ValuationReportResultProps) => {
    const { valuationState, valuationFiltersState } = useContext(PropertyValuationContext);
    const { valuationResultV2 } = valuationState;

    const resultRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!valuationState.isLoading && valuationResultV2) {
            resultRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [valuationState.isLoading, valuationResultV2]);

    if (!valuationResultV2) return null;

    const locationLabel = Object.values(valuationFiltersState.savedLocations)[0]?.label;
    const subjectAddress = `${locationLabel} ${valuationFiltersState.buildingNumber || ''}`.trim() || undefined;

    return (
        <ReportWrapper ref={resultRef}>
            <Title>Wyniki wyceny nieruchomości</Title>

            <ValuationHeroCard
                hero={valuationResultV2.heroSection}
                subjectAddress={subjectAddress}
                onExportPdf={onExportPdf}
                isExportingPdf={isExportingPdf}
            />

            {valuationResultV2.marketProofSection &&
                <ValuationMarketProof section={valuationResultV2.marketProofSection} />
            }

            {valuationResultV2.marketContextSection &&
                <ValuationMarketContext section={valuationResultV2.marketContextSection} />
            }

            {valuationResultV2.planBSection &&
                <ValuationPlanB section={valuationResultV2.planBSection} />
            }

            {valuationResultV2.locationSection &&
                <ValuationLocation section={valuationResultV2.locationSection} />
            }

            {valuationResultV2.aiSummarySection &&
                <ValuationAiSummary section={valuationResultV2.aiSummarySection} />
            }
        </ReportWrapper>
    );
};

export default ValuationReportResult;
